import * as faceapi from 'face-api.js';

const loadModels = async () => {
  const MODEL_URL = '/models/ssd_mobilenetv1_model';

  await Promise.all([
    faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL),
  ]);
};

const detectFace = async (image) => {
  const options = new faceapi.SsdMobilenetv1Options({ minConfidence: 0.2 });
  const detections = await faceapi.detectAllFaces(image, options);
  return detections;
};

const validateFaceImage = async (file) => {
  await loadModels();

  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = async () => {
      const detections = await detectFace(img);

      if (detections.length === 0) {
        resolve('no-face'); // No se detectó rostro
        return;
      }

      // Validar que el rostro sea de tamaño razonable
      const largest = detections.reduce((a, b) =>
        a.box.width * a.box.height > b.box.width * b.box.height ? a : b
      );

      const minWidth = img.width * 0.1;  // Baja el umbral para permitir partes del rostro
      const minHeight = img.height * 0.1;

      if (largest.box.width < minWidth || largest.box.height < minHeight) {
        resolve('too-small'); // Rostro muy pequeño
        return;
      }


      //Validar oscuridad y desenfoque solo si hay rostro válido
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
        
      if (isImageTooDark(canvas)) {
        resolve('too-dark');
        return;
      } else if (isImageBlurry(canvas)) {
        resolve('blurry');
        return;
      }
    
      resolve('ok');
    };

    img.onerror = () => resolve('no-face');
  });
};

const isImageBlurry = (canvas) => {
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const gray = new Uint8ClampedArray(imageData.width * imageData.height);

  for (let i = 0; i < imageData.data.length; i += 4) {
    gray[i / 4] = 0.2989 * imageData.data[i] + 0.587 * imageData.data[i + 1] + 0.114 * imageData.data[i + 2];
  }

  let variance = 0;
  for (let i = 1; i < gray.length - 1; i++) {
    const laplacian = gray[i - 1] + gray[i + 1] - 2 * gray[i];
    variance += laplacian * laplacian;
  }
  variance /= gray.length;

  return variance < 40; // Ajusta el umbral si es necesario
};

const isImageTooDark = (canvas) => {
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let totalBrightness = 0;

  for (let i = 0; i < imageData.data.length; i += 4) {
    const r = imageData.data[i];
    const g = imageData.data[i + 1];
    const b = imageData.data[i + 2];
    const brightness = (r + g + b) / 3;
    totalBrightness += brightness;
  }

  const avgBrightness = totalBrightness / (imageData.data.length / 4);
  return avgBrightness < 35; // Ajusta este umbral si deseas
};


export default validateFaceImage;